import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  awardList: {
    requesting: false,
    items: [],
    pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
    error: null,
    success: false,
    filters: {},
  },
  awardDetails: {
    requesting: false,
    data: null,
    error: null,
    success: false,
  },
}

export const awardSlice = createSlice({
  name: 'award',
  initialState,
  reducers: {
    getAwardList: (state, action) => {
      state.awardList.requesting = true
      state.awardList.error = null
      state.awardList.items = []
      state.awardList.success = false
      state.awardList.filters = action.payload
    },
    getAwardListSuccess: (state, action) => {
      const { data, current_page, per_page, total } = action.payload
      state.awardList.requesting = false
      state.awardList.items = data
      state.awardList.success = true
      state.awardList.pagination.current_page = current_page
      state.awardList.pagination.per_page = per_page
      state.awardList.pagination.total = total
    },
    getAwardListFail: (state, action) => {
      state.awardList.requesting = false
      state.awardList.error = action.payload
    },
    getAwardDetails: (state) => {
      state.awardDetails.requesting = true
      state.awardDetails.error = null
      state.awardDetails.data = null
      state.awardDetails.success = false
    },
    getAwardDetailsSuccess: (state, action) => {
      state.awardDetails.requesting = false
      state.awardDetails.data = action.payload
      state.awardDetails.success = true
    },
    getAwardDetailsFail: (state, action) => {
      state.awardDetails.requesting = false
      state.awardDetails.error = action.payload
    },
    doAwardCreate: (state) => {
      state.awardDetails.requesting = true
      state.awardDetails.error = null
      state.awardDetails.data = null
      state.awardDetails.success = false
    },
    doAwardCreateSuccess: (state, action) => {
      state.awardDetails.requesting = false;
      state.awardDetails.data = action.payload;
      state.awardDetails.success = true;
    },
    doAwardCreateFail: (state, action) => {
      state.awardDetails.requesting = false;
      state.awardDetails.error = action.payload;
      state.awardDetails.success = false;
    },
    doAwardUpdate: (state) => {
      state.awardDetails.requesting = true
      state.awardDetails.error = null
      state.awardDetails.data = null
      state.awardDetails.success = false
    },
     doAwardUpdateSuccess: (state, action) => {
      state.awardDetails.requesting = false;
      state.awardDetails.data = action.payload;
      state.awardDetails.success = true;
    },
    doAwardUpdateFail: (state, action) => {
      state.awardDetails.requesting = false;
      state.awardDetails.error = action.payload;
      state.awardDetails.success = false;
    },
    doAwardDelete: (state) => {
      state.awardDetails.requesting = true
      state.awardDetails.error = null
      state.awardDetails.data = null
      state.awardDetails.success = false
    },
    doAwardReset: (state) => {
      state.awardDetails.data = null
    },
  },
})

export const {
  getAwardList,
  getAwardListSuccess, doAwardCreateSuccess,
  getAwardListFail, doAwardCreateFail,
  getAwardDetails, getAwardDetailsSuccess,
  getAwardDetailsFail, doAwardCreate,
  doAwardUpdateSuccess, doAwardUpdateFail,
  doAwardUpdate, doAwardDelete,
  doAwardReset,
} = awardSlice.actions

export default awardSlice.reducer
